import { z } from "zod";

export const EXPENSE_CATEGORIES = [
  "rent",
  "utilities",
  "equipment",
  "maintenance",
  "marketing",
  "salaries",
  "credits",
  "taxes",
  "other",
] as const;

export type ExpenseCategoryKey = (typeof EXPENSE_CATEGORIES)[number];

export const EXPENSE_CLASSIFICATION_VALUES = [
  "OPERATIONAL",
  "NON_OPERATIONAL",
] as const;

export type ExpenseClassificationValue =
  (typeof EXPENSE_CLASSIFICATION_VALUES)[number];

const classificationValueSchema = z.enum(EXPENSE_CLASSIFICATION_VALUES);

const categoryClassificationSchema = z.object({
  rent: classificationValueSchema,
  utilities: classificationValueSchema,
  equipment: classificationValueSchema,
  maintenance: classificationValueSchema,
  marketing: classificationValueSchema,
  salaries: classificationValueSchema,
  credits: classificationValueSchema,
  taxes: classificationValueSchema,
  other: classificationValueSchema,
});

export const gymExpensesConfigSchema = z.object({
  gymPublicId: z.string(),
  categoryClassification: categoryClassificationSchema,
});

export type GymExpensesConfig = z.infer<typeof gymExpensesConfigSchema>;

export type ExpenseCategoryClassification = z.infer<
  typeof categoryClassificationSchema
>;

export const updateGymExpensesConfigInputSchema = z.object({
  categoryClassification: categoryClassificationSchema
    .partial()
    .refine((d) => Object.keys(d).length > 0, {
      message: "Debe incluir al menos una categoría",
    }),
});

export type UpdateGymExpensesConfigInput = z.infer<
  typeof updateGymExpensesConfigInputSchema
>;
